import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import ReactModal from 'react-modal';
import CloseButton from './close-button.jsx';
import CheckboxButton from '../checkbox-button/checkbox-button.jsx';
import warning from './images/warning.png';

import style from './media-modal.css';
import {scratchView, scratchClick} from '../../utils/xes-analytice';
import {getDeviceStatus} from '../../utils';

class MediaModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleVideoChange',
            'handleAudioChange',
            'handleStartRecord',
            'clickShareHandle',
            'handleOnShare',
            'clickCloseModal'
        ]);
        this.state = {
            videoOn: true,
            audioOn: true,
            selectedTab: this.props.selectedTab || '项目分享'
        };
    }
    componentDidMount () {
        if (this.props.onAudio && typeof this.props.onAudio === 'function') {
            this.props.onAudio(true);
        }
        if (this.props.onVideo && typeof this.props.onVideo === 'function') {
            this.props.onVideo(true);
        }

        if (this.props.selectedTab === '项目分享' && this.props.savedTab === '项目分享') this.handleOnShare()
            this.setState({
                selectedTab: this.props.savedTab
            });
        scratchView('view_xiaohou_share_step1', {
            language: 'Scratch',
            editor: 'Scratch编辑器',
            scene: '社区创作',
            bundle_id: '',
            question_id: ''
        });
  
    }
    clickShareHandle(type) {
        this.setState({
            selectedTab: type
        });
        if (this.props.onSaveTab && typeof this.props.onSaveTab === 'function') {
            this.props.onSaveTab(type);
        }
        if (type === '项目分享') this.handleOnShare()
    }
    handleAudioChange (checked, event) {
        this.setState({
            audioOn: checked
        });
        if (this.props.onAudio && typeof this.props.onAudio === 'function') {
            this.props.onAudio(checked, event);
        }
    }
    handleVideoChange (checked, event) {
        this.setState({
            videoOn: checked
        });
        if (this.props.onVideo && typeof this.props.onVideo === 'function') {
            this.props.onVideo(checked, event);
        }
    }
    handleStartRecord () {
        const {videoOn, audioOn} = this.state;
        scratchClick('click_xiaohou_share_step1', {
            language: 'Scratch',
            editor: 'Scratch编辑器',
            scene: '社区创作',
            bundle_id: '',
            question_id: '',
            button_name: '录制视频',
            status: getDeviceStatus(videoOn, audioOn)
        });
        if (this.props.onRecord && typeof this.props.onRecord === 'function') {
            this.props.onRecord(true);
        }
        if (this.props.onCloseModal && typeof this.props.onCloseModal === 'function') {
            this.props.onCloseModal();
        }
    }
    handleOnShare () {
        const {videoOn, audioOn} = this.state;
        scratchClick('click_xiaohou_share_step1', {
            language: 'Scratch',
            editor: 'Scratch编辑器',
            scene: '社区创作',
            bundle_id: '',
            question_id: '',
            button_name: '仅分享项目',
            status: getDeviceStatus(videoOn, audioOn)
        });
        if (this.props.onShare && typeof this.props.onShare === 'function') {
            this.props.onShare();
        }
    }

    clickCloseModal () {
        if (this.props.onCloseModal && typeof this.props.onCloseModal === 'function') {
            this.props.onCloseModal(true);
        }
    }

    render () {
        const {onCloseModal, singleVideoPoint, onResetShareStatus} = this.props;
        const { selectedTab } = this.state;
        return (
            <ReactModal
                className={style.content}
                contentLabel="项目分享"
                isOpen
                onRequestClose={this.clickCloseModal}
                overlayClassName={style.overlay}
                shouldCloseOnOverlayClick={false}
            >
                <CloseButton onClick={this.clickCloseModal} />
                {/* <div className={style.title}>{'项目分享'}</div> */}
                <div className={style.shareTop}>
                    <div className={classNames(style.topItem, {[style.topItemActive]: selectedTab === '项目分享'})}>
                        <span onClick={() => {this.clickShareHandle('项目分享')}}>项目分享</span>
                        {selectedTab === '项目分享' ? <div className={style.activeBorder}></div> : null}
                    </div>
                    <div className={classNames(style.topItem, {[style.topItemActive]: selectedTab === '视频录制'})}>
                        <span onClick={() => {this.clickShareHandle('视频录制')}}>视频录制</span>
                        {selectedTab === '视频录制' ? <div className={style.activeBorder}></div> : null}
                    </div>
                </div>
                {/* <div className={style.subtitle}>
                    <span>{'限时'}</span>
                    { '录视频分享作品，可获得' }{singleVideoPoint}{'积分'}
                    <span>{'(每日上限60积分)'}</span>
                </div> */}
                <div style={{height:'24px'}}></div>
                <div className={style.mediaContainer}>
                    <div className={classNames(style.buttonContainer, style.audioButtonContainer)}>
                        <div className={style.iconVoice} />
                        <CheckboxButton
                            className={style.checkboxButton}
                            defaultChecked
                            onChange={this.handleAudioChange}
                        />
                    </div>
                    <div className={style.buttonContainer}>
                        <div className={style.iconVideo} />
                        <CheckboxButton
                            className={style.checkboxButton}
                            defaultChecked
                            onChange={this.handleVideoChange}
                        />
                    </div>
                </div>
                <div className={style.tools}>
                    {/* <button
                        className={style.button}
                        onClick={this.handleOnShare}
                    >{'仅分享项目'}</button> */}
                    <button
                        className={classNames(style.button, style.buttonGreen)}
                        onClick={this.handleStartRecord}
                    >{'录制视频'}</button>
                </div>
                <p className={style.warning}>
                    <img src={warning} />
                    {'分享后，项目支持：鼠标点击，方向键，空格键和数字0-9的输入'}
                </p>
            </ReactModal>
        );
    }
}

MediaModal.propTypes = {
    onRecord: PropTypes.func,
    onVideo: PropTypes.func,
    onAudio: PropTypes.func,
    onShare: PropTypes.func,
    onCloseModal: PropTypes.func,
    selectedTab: PropTypes.string,
    singleVideoPoint: PropTypes.number,
    savedTab: PropTypes.string,
    onSaveTab: PropTypes.func
};

export default MediaModal;
